/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetSponsorPostEventReportQueryVariables = Types.Exact<{
  sponsor_company_slug?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type GetSponsorPostEventReportQuery = {
  sponsorPostEventReport?: Types.Maybe<
    Pick<
      Types.FileFieldAnswerType,
      "id" | "name" | "mime_type" | "uri" | "expiry"
    >
  >;
};

export const GetSponsorPostEventReportDocument = gql`
  query GetSponsorPostEventReport($sponsor_company_slug: String) {
    sponsorPostEventReport(sponsor_company_slug: $sponsor_company_slug) {
      id
      name
      mime_type
      uri
      expiry
    }
  }
`;

/**
 * __useGetSponsorPostEventReportQuery__
 *
 * To run a query within a React component, call `useGetSponsorPostEventReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSponsorPostEventReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSponsorPostEventReportQuery({
 *   variables: {
 *      sponsor_company_slug: // value for 'sponsor_company_slug'
 *   },
 * });
 */
export function useGetSponsorPostEventReportQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSponsorPostEventReportQuery,
    GetSponsorPostEventReportQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetSponsorPostEventReportQuery,
    GetSponsorPostEventReportQueryVariables
  >(GetSponsorPostEventReportDocument, baseOptions);
}
export function useGetSponsorPostEventReportLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSponsorPostEventReportQuery,
    GetSponsorPostEventReportQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetSponsorPostEventReportQuery,
    GetSponsorPostEventReportQueryVariables
  >(GetSponsorPostEventReportDocument, baseOptions);
}
export type GetSponsorPostEventReportQueryHookResult = ReturnType<
  typeof useGetSponsorPostEventReportQuery
>;
export type GetSponsorPostEventReportLazyQueryHookResult = ReturnType<
  typeof useGetSponsorPostEventReportLazyQuery
>;
export type GetSponsorPostEventReportQueryResult =
  ApolloReactCommon.QueryResult<
    GetSponsorPostEventReportQuery,
    GetSponsorPostEventReportQueryVariables
  >;
